import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import jsonData from "../../assets/json/test.json";
@Injectable({
  providedIn: 'root'
})
export class SitesBuilderService {
  private bucketRoot = '/sitesbuilder';

  mapData: {
    venueId: string,
    mapId: string
  }
  mapData$: BehaviorSubject<any>;
  private appData = jsonData;
  constructor(private http: HttpClient) {
  }

  public getS3Info$(site): Observable<any> {
    /* return of(this.appData); */
    return this.http.get<any>(environment.s3Url + this.bucketRoot + '/' + site + '/latest/master.json');
  }

  public getFile(path): Observable<any> {
    /* return of(searcherFile); */
    return this.http.get(environment.s3Url + path, { responseType: 'blob' });
  }

  public getMapData$(): Observable<any> {
    return this.mapData$.asObservable();
  }
  public setMapData(data: { venueId: string, mapId: string }) {
    this.mapData = data;
    if (!this.mapData$) {
      this.mapData$ = new BehaviorSubject<any>(this.mapData);
    }
    this.mapData$.next(this.mapData);
  }
  public deleteMapData() {
    this.mapData = undefined;
    this.mapData$ = undefined;
  }
}
